import {
  LOGIN_SUCCESS,
  TREATMENT_INSTANCES_GET_REQUEST,
  TREATMENT_INSTANCES_GET_SUCCESS,
  TREATMENT_INSTANCES_GET_FAILURE,
  REMOVE_TREATMENT_INSTANCE,
  TREATMENT_INSTANCES_BY_ASSIGNMEN_GET_SUCCESS,
  TREATMENT_INSTANCE_COPY_GET_SUCCESS,
  REMOVE_TREATMENT_INSTANCE_COPIES,
  UPDATE_TIME_LEFT_TO_ALLOCATE,
  REMOVE_COPY_TREATMENT_INSTANCE,
} from '../../../actions/constants/types';

const initialTreatmentsState = {
  isFetching: false,
  items: [],
  unallocatedTime: {},
  lastUpdated: null,
};

function treatmentInstances(state = initialTreatmentsState, action) {
  switch (action.type) {
    case TREATMENT_INSTANCES_GET_REQUEST:
      return { ...state, isFetching: !action.silent };
    case TREATMENT_INSTANCES_GET_SUCCESS:
      return {
        ...state,
        isFetching: false,
        items: action.response.data.treatmentInstances,
        unallocatedTime: action.response.data.unallocatedTime,
        lastUpdated: action.receivedAt,
      };
    case TREATMENT_INSTANCES_GET_FAILURE:
    case LOGIN_SUCCESS:
      return initialTreatmentsState;
    case REMOVE_TREATMENT_INSTANCE: {
      const newItems = [
        ...state.items.filter(
          v =>
            !(
              v.treatmentId === action.treatmentId &&
              v.occurrence === action.occurrence &&
              v.effectiveTimeSlots.every(
                ts =>
                  action.effectiveTimeSlots.map(ats => ats.from).includes(ts.from) &&
                  action.effectiveTimeSlots.map(ats => ats.to).includes(ts.to),
              )
            ),
        ),
      ];
      return {
        ...state,
        items: newItems,
      };
    }
    case REMOVE_COPY_TREATMENT_INSTANCE:
      return {
        ...state,
        items: [...state.items.filter(v => v.assignGuid !== action.assignGuid)],
      };
    case TREATMENT_INSTANCES_BY_ASSIGNMEN_GET_SUCCESS: {
      const items = [...state.items];
      const treatmentInstancesMap = [...action.response.data.treatmentInstance];
      treatmentInstancesMap.forEach(item => {
        if (!items.find(v => v.assignGuid === item.assignGuid)) items.push(item);
      });
      return {
        ...state,
        items,
      };
    }
    case TREATMENT_INSTANCE_COPY_GET_SUCCESS: {
      const newCopies = action.response.data.treatmentInstance;
      return {
        ...state,
        items: [...state.items, ...newCopies],
      };
    }
    case REMOVE_TREATMENT_INSTANCE_COPIES: {
      return {
        ...state,
        items: [...state.items.filter(v => v.masterId !== action.masterId)],
      };
    }
    case UPDATE_TIME_LEFT_TO_ALLOCATE: {
      const times = Object.values(state.unallocatedTime);
      const timeInMinutes = times[0] * 60 + (times[1] - action.duration);
      const hours = parseInt(timeInMinutes / 60, 10);
      const minutes = timeInMinutes - hours * 60;
      const unallocatedTime = { hours, minutes };

      return {
        ...state,
        unallocatedTime,
      };
    }
    default:
      return state;
  }
}

export default treatmentInstances;
